import Header from './components/Header';
import HeroSection from './components/HeroSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <UpdatesSection />
        <AppSection />
        <IndexSection />
        <CardsSection />
        <RankingSection />
        <FaqSection />
        <MediaSection />
        <FeaturesSection />
        <CarouselSection />
        <ContactSection />
        <TopicsSection />
        <AboutSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}